module.exports = __webpack_public_path__ + "static/media/web-ats-03.7180ba3a.jpg";